import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// CRITICAL: mount the React app FIRST. Anything that touches the network,
// service workers, caches or localStorage MUST run after the root has been
// rendered – otherwise a single thrown exception (e.g. localStorage access
// blocked, caches API missing in private mode, etc.) would leave the user
// stuck on the static loading splash forever.
createRoot(document.getElementById("root")!).render(<App />);

// One-time cleanup of any leftover Service Worker / cached assets from the
// previous PWA build. The old worker was caching a stale index.html and
// trapping users on the splash screen. We mark the cleanup as done in
// localStorage so we only run it once per browser. EVERY operation here is
// wrapped in try/catch because failing this cleanup must NEVER break the app.
try {
  const SW_CLEANUP_KEY = "napihami_sw_cleanup_v2";
  if (typeof window !== "undefined" && !localStorage.getItem(SW_CLEANUP_KEY)) {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          registrations.forEach((registration) => {
            registration.unregister().catch(() => {});
          });
        })
        .catch(() => {});
    }
    if (typeof caches !== "undefined" && caches.keys) {
      caches
        .keys()
        .then((keys) => {
          keys.forEach((key) => {
            caches.delete(key).catch(() => {});
          });
        })
        .catch(() => {});
    }
    try {
      localStorage.setItem(SW_CLEANUP_KEY, "1");
    } catch {
      // ignore quota / private mode errors
    }
  }
} catch {
  // Defensive: never let the SW cleanup throw and prevent the app from running.
}
